var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "files_block" },
    [
      _c(
        "div",
        { staticClass: "add_file" },
        [
          _vm.can_add
            ? _c("fileloader", {
                key: "file_loader_mem",
                attrs: {
                  doc_type: "memorandum",
                  doc_id: _vm.get_doc_id,
                  trigger_load: _vm.file_triger,
                  can_del: true,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        staticClass: "table-responsive-lg",
        attrs: {
          "thead-class": _vm.head_class,
          striped: "",
          items: _vm.files,
          fields: _vm.fields,
        },
        scopedSlots: _vm._u([
          {
            key: "head(link)",
            fn: function (data) {
              return [
                _c("span", {
                  staticClass: "fs-xl text-center",
                  domProps: { innerHTML: _vm._s(data.label) },
                }),
              ]
            },
          },
          {
            key: "head(remove)",
            fn: function (data) {
              return [
                _c("span", {
                  staticClass: "fs-xl text-center",
                  domProps: { innerHTML: _vm._s(data.label) },
                }),
              ]
            },
          },
          {
            key: "cell(link)",
            fn: function (data) {
              return [
                _c(
                  "span",
                  {
                    staticClass: "get_file cursor-pointer",
                    on: {
                      click: function ($event) {
                        return _vm.get_file(data.item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fal fa-save save_me" })]
                ),
              ]
            },
          },
          {
            key: "cell(remove)",
            fn: function (data) {
              return [
                _c("i", {
                  staticClass: "fas fa-trash fs-xl",
                  on: {
                    click: function ($event) {
                      return _vm.remove_item(data.item)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }